/******** Reducers ********/

const initialState = {
  loggedIn: false,
  notifications: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':

      // Spread the initial user data and add a dynamically populated supplier_id
      const userData = { 
        ...state, 
        ...{ loggedIn: true }, 
        ...action.data, 
        supplier_id: action.data?.supplier_id?._id ? { ...action.data.supplier_id, id: action.data.supplier_id?.id || action.data.supplier_id?._id } : null 
      };
      // Extract main userId, falling back to the first available value
      const mainUserId = userData?.supplier_id?.id || userData?.supplier_id?._id || userData?.id || userData?._id;
let updatedUserData={ ...userData,mainUserId: mainUserId}
      if(userData?.supplier_id?.id||userData?.supplier_id?._id){
       updatedUserData = {
        ...userData,
        mainUserId: mainUserId,
        companyDateFormat: userData?.supplier_id?.companyDateFormat || userData?.companyDateFormat,
        isPerOrder: userData?.supplier_id?.isPerOrder || userData?.isPerOrder,
        gmail_sync: userData?.supplier_id?.gmail_sync || userData?.gmail_sync,
        outlook_email_sync: userData?.supplier_id?.outlook_email_sync || userData?.outlook_email_sync,
        companyCurrencyFormat: userData?.supplier_id?.companyCurrencyFormat || userData?.companyCurrencyFormat,
        gPropertyIds: userData?.supplier_id?.gPropertyIds || userData?.gPropertyIds,
        analyticsConnected: userData?.supplier_id?.analyticsConnected || userData?.analyticsConnected,
        rezdyCron: userData?.supplier_id?.rezdyCron || userData?.rezdyCron,
        tripAdvisorConnection: userData?.supplier_id?.tripAdvisorConnection || userData?.tripAdvisorConnection,
        googleConnection: userData?.supplier_id?.googleConnection || userData?.googleConnection,
        isVerified: userData?.supplier_id?.isVerified || userData?.isVerified,
        trial_ended: userData?.supplier_id?.trial_ended || userData?.trial_ended,
        on_trial: userData?.supplier_id?.on_trial || userData?.on_trial,
        invite_email: userData?.supplier_id?.invite_email || userData?.invite_email,
        free_plan_purchase: userData?.supplier_id?.free_plan_purchase || userData?.free_plan_purchase,
        two_factor: userData?.supplier_id?.two_factor || userData?.two_factor,
        gmail_connection: userData?.supplier_id?.gmail_connection || userData?.gmail_connection,
        partner_status: userData?.supplier_id?.partner_status || userData?.partner_status,
        booking_system_status: userData?.supplier_id?.booking_system_status || userData?.booking_system_status,
        review_status: userData?.supplier_id?.review_status || userData?.review_status,
        product_syncing: userData?.supplier_id?.product_syncing || userData?.product_syncing,
        order_syncing: userData?.supplier_id?.order_syncing || userData?.order_syncing,
        xero_invoices_syncing: userData?.supplier_id?.xero_invoices_syncing || userData?.xero_invoices_syncing,
        xero_bank_transaction_syncing: userData?.supplier_id?.xero_bank_transaction_syncing || userData?.xero_bank_transaction_syncing,
        xero_bills_to_pay_syncing: userData?.supplier_id?.xero_bills_to_pay_syncing || userData?.xero_bills_to_pay_syncing,
        profile_completion_step: userData?.supplier_id?.profile_completion_step || userData?.profile_completion_step,
        approved: userData?.supplier_id?.approved || userData?.approved,
        reseller_invoice_prefix_type: userData?.supplier_id?.reseller_invoice_prefix_type || userData?.reseller_invoice_prefix_type,
        reseller_invoice_prefix_remember: userData?.supplier_id?.reseller_invoice_prefix_remember || userData?.reseller_invoice_prefix_remember,
        fb_messages_syncing: userData?.supplier_id?.fb_messages_syncing || userData?.fb_messages_syncing,
        review_poup: userData?.supplier_id?.review_poup || userData?.review_poup,
        companyName: userData?.supplier_id?.companyName || userData?.companyName,
        companymobileno: userData?.supplier_id?.companymobileno || userData?.companymobileno,
        gmail_account_id: userData?.supplier_id?.gmail_account_id || userData?.gmail_account_id,
        gmail_refresh: userData?.supplier_id?.gmail_refresh || userData?.gmail_refresh,
        subscription_currency: userData?.supplier_id?.subscription_currency || userData?.subscription_currency,
        customer_id: userData?.supplier_id?.customer_id || userData?.customer_id,
        stripe_subscriptionId: userData?.supplier_id?.stripe_subscriptionId || userData?.stripe_subscriptionId,
        facebook_long_token: userData?.supplier_id?.facebook_long_token || userData?.facebook_long_token,
        facebook_page_id: userData?.supplier_id?.facebook_page_id || userData?.facebook_page_id,
        facebook_token: userData?.supplier_id?.facebook_token || userData?.facebook_token,
        fb_page_name: userData?.supplier_id?.fb_page_name || userData?.fb_page_name,
        lastLogin: userData?.supplier_id?.lastLogin || userData?.lastLogin,
        accessToken: userData?.supplier_id?.accessToken || userData?.accessToken,
        gAccountId: userData?.supplier_id?.gAccountId || userData?.gAccountId,
        refresh_token: userData?.supplier_id?.refresh_token || userData?.refresh_token,
        isEnter: userData?.supplier_id?.isEnter || userData?.isEnter,
        ig_messages_syncing: userData?.supplier_id?.ig_messages_syncing || userData?.ig_messages_syncing,
        locationId: userData?.supplier_id?.locationId || userData?.locationId,
        enableCountryDetection: userData?.supplier_id?.enableCountryDetection || userData?.enableCountryDetection,
        analyticsAccessToken: userData?.supplier_id?.analyticsAccessToken || userData?.analyticsAccessToken,
        analyticsAccountId: userData?.supplier_id?.analyticsAccountId || userData?.analyticsAccountId,
        analytics_refresh_token: userData?.supplier_id?.analytics_refresh_token || userData?.analytics_refresh_token,
        propertyId: userData?.supplier_id?.propertyId || userData?.propertyId,
        notSignedReminder: userData?.supplier_id?.notSignedReminder || userData?.notSignedReminder,
        xeroRefresh: userData?.supplier_id?.xeroRefresh || userData?.xeroRefresh,
        xeroToken: userData?.supplier_id?.xeroToken || userData?.xeroToken||null,
        xero_tenant_name: userData?.supplier_id?.xero_tenant_name || userData?.xero_tenant_name,
        wba_id: userData?.supplier_id?.wba_id || userData?.wba_id,
        wba_token: userData?.supplier_id?.wba_token || userData?.wba_token,
        waba_id: userData?.supplier_id?.waba_id || userData?.waba_id,
        waba_token: userData?.supplier_id?.waba_token || userData?.waba_token,
        addPartner: userData?.supplier_id?.addPartner || userData?.addPartner,
        contactPerson: userData?.supplier_id?.contactPerson || userData?.contactPerson,
        position: userData?.supplier_id?.position || userData?.position,
        analyticsAccountEmail: userData?.supplier_id?.analyticsAccountEmail || userData?.analyticsAccountEmail,
        analyticsAccountName: userData?.supplier_id?.analyticsAccountName || userData?.analyticsAccountName,
        paypal_subscriptionId: userData?.supplier_id?.paypal_subscriptionId || userData?.paypal_subscriptionId,
        myob_accesstoken: userData?.supplier_id?.myob_accesstoken || userData?.myob_accesstoken,
        myob_status: userData?.supplier_id?.myob_status || userData?.myob_status,
        quick_book_status: userData?.supplier_id?.quick_book_status || userData?.quick_book_status,
        sendSmsForMissingFields: userData?.supplier_id?.sendSmsForMissingFields || userData?.sendSmsForMissingFields,
        sendEmailForMissingFields: userData?.supplier_id?.sendEmailForMissingFields || userData?.sendEmailForMissingFields,
        isPartners: userData?.supplier_id?.isPartners || userData?.isPartners,
        quick_book_accesToken: userData?.supplier_id?.quick_book_accesToken || userData?.quick_book_accesToken,
        currencyDetails: userData?.supplier_id?.currencyDetails || userData?.currencyDetails,
        enabledProducts: userData?.supplier_id?.enabledProducts || userData?.enabledProducts,
        tripaAdvisorRewisConnect: userData?.supplier_id?.tripaAdvisorRewisConnect || userData?.tripaAdvisorRewisConnect,
        googleReviewsConnect: userData?.supplier_id?.googleReviewsConnect || userData?.googleReviewsConnect,
        facebookReviewsConnect: userData?.supplier_id?.facebookReviewsConnect || userData?.facebookReviewsConnect,
        gMBStatus: userData?.supplier_id?.gMBStatus || userData?.gMBStatus,
        enabledSettings: userData?.supplier_id?.enabledSettings || userData?.enabledSettings,
        alertSettings: userData?.supplier_id?.alertSettings || userData?.alertSettings,
      };
    }

      return updatedUserData;
      
    case 'LOG_OUT':
      localStorage.setItem('logout', new Date());
      localStorage.removeItem('token');
      return initialState;

    default:
      if (localStorage.getItem('token')) {
        return state;
      } else {
        return initialState;
      }
  }
}
